import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { FiSearch } from 'react-icons/fi'
import { HiOutlinePlus } from 'react-icons/hi'
import { MdDelete } from 'react-icons/md'
import { cleanFilterObject } from 'safe'
import ModalConfirm from '../Display/ModalConfirm'
import Button, { ButtonType } from '../General/Button'
// import InputText from '../Inputs/InputText'
import SelectOfCategories from '../Inputs/SelectOfCategories'
import Switch from '../Inputs/Switch'
import { useHistory, useLocation } from 'react-router-dom'
import { GiHamburgerMenu, GiTakeMyMoney } from 'react-icons/gi'
import { AiFillPrinter, AiOutlineRead } from 'react-icons/ai'
import { IoIosCloudDone } from 'react-icons/io'
import InputText from '../Inputs/InputText'
import Tooltip from '../Display/Tooltip'
import AdvancedSearch from '../Inputs/AdvancedSearch'
import { RiArrowDownSLine } from 'react-icons/ri'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { toFixed } from 'accounting'
import { formatPipe } from '../../utils/utils'

/**
 * Componente de Header que muestra componentes en la parte superiror
 *  dependiendo del setHeaderActions.
 * Se llama en el MainContent.tsx
 * @param {string} title se encarga de mostrar el titulo de la page actual.
 * @param {HeaderActions} headerActions objeto del tipo HeaderActions pasado en el
 * MainContent.
 */

const Header: React.FC<HeaderProps> = ({
  title,
  headerActions,
  setCollapsed,
}) => {
  const location = useLocation()

  const msgToShow = {
    0: '¿Está seguro que desea pasarse a venta?',
    1: '¿Está seguro que desea pasarse a forma libre?',
  }

  const [isSearch, setIsSearch] = useState(
    headerActions?.cleanFilters?.isSearch
  )

  const refSearchInput = useRef<HTMLInputElement | null>(null)

  const [checked, setChecked] = useState<boolean>(false)

  const [checkedSale, setCheckedSale] = useState<boolean>(false)

  const [checkPayed, setCheckPayed] = useState<boolean>(false)

  const [isDeliveryNote, setIsDeliveryNote] = useState<boolean>(false)

  const [isModifyFreeForm, setIsModifyFreeForm] = useState<boolean>(false)

  const [checkRevert, setCheckRevert] = useState<boolean>(false)

  const [addTitle, setAddTitle] = useState({
    '/dashboard/inventario/inventory': 'artículo',
    '/dashboard/inventario/categorias': 'categoría',
    '/dashboard/terceros/clientes': 'clientes',
    '/dashboard/terceros/proveedores': 'proveedores',
    '/dashboard/finanzas/ingreso': 'entrada',
    '/dashboard/finanzas/egreso': 'salida',
    '/dashboard/contabilidad/plan_de_cuentas': '',
    '/dashboard/contabilidad/registros_contables': 'registro contable',
    '/dashboard/bancos/bancos': 'cuenta',
    '/dashboard/inventario/existencia': 'almacén',
    '/dashboard/inventario/servicios': 'servicio'
  })

  const userRole = useSelector((state: RootState) => state?.auth?.user)

  const rates = useSelector((state: RootState) => state?.rates?.rates)

  // const [usdRate, setUsdRate] = useState(null)

  // const [titleValue, setTitlevalue] = useState('')

  const [listOfTypes] = useState([
    { text: 'Factura', value: 'all' },
    // { text: 'Venta por factura', value: 'invoice' },
    // { text: 'Venta por forma libre', value: 'freeForm' },
    { text: 'Nota de entrega', value: 'deliveryNote' },
  ])

  const [listOfDelivery] = useState([
    { text: 'No despachado', value: 'UNDISPATCHED' },
    { text: 'Despachado', value: 'DISPATCHED' },
  ])

  const [listOfSalesType] = useState([
    { text: 'Factura', value: 'sale' },
    { text: 'Nota de entrega', value: 'deliveryNote' },
  ])

  const [listOfSales] = useState([
    { text: 'Factura', value: 'REFUND' },
    { text: 'Nota de entrega', value: 'DELIVERY_NOTE' },
    { text: 'Talonario', value: 'COUNTERFOIL' },
  ])

  const [selectedDelivery, setSelectedDelivery] = useState(listOfDelivery[0])

  // const refInputSearch = useRef<HTMLInputElement>(null)

  const history = useHistory()

  const refInputAdvanced = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    setIsSearch(headerActions?.cleanFilters?.isSearch)
  }, [headerActions?.advancedSearch, headerActions?.searchAction])

  // useEffect(() => {
  //   console.log("RATES HEADER", rates)
  //   setUsdRate(rates?.find(rate => rate?.id === "1")?.rate)
  // }, [rates])

  useEffect(() => {
    headerActions &&
      headerActions.onFreeForm &&
      headerActions.onFreeForm(checkedSale, setCheckedSale)
    /* Para que solo funcione en la page de ventas */
    if (
      headerActions &&
      Object.keys(headerActions).length !== 3 &&
      Object.keys(headerActions).length !== 1
    ) {
      setCheckedSale(false)
    }
  }, [headerActions?.onFreeForm])

  useEffect(() => {
    if (checked && !location.pathname.includes('/historicoventas')) {
      setChecked(false)
    }
  }, [headerActions?.onFilterSales])

  useEffect(() => {
    headerActions &&
      headerActions.onPayed &&
      headerActions.onPayed(checkPayed, setCheckPayed)
    if (checkPayed && !location.pathname.includes('/notaventa')) {
      setCheckPayed(false)
    }
  }, [headerActions?.onPayed])

  useEffect(() => {
    if (checkPayed) {
      setSelectedDelivery(listOfDelivery[1])
      headerActions &&
        headerActions.onChangeDeliveryStatus &&
        headerActions.onChangeDeliveryStatus(listOfDelivery[1].value)
    } else {
      setSelectedDelivery(listOfDelivery[0])
      headerActions &&
        headerActions.onChangeDeliveryStatus &&
        headerActions.onChangeDeliveryStatus(listOfDelivery[0].value)
    }
  }, [checkPayed])

  useEffect(() => {
    console.log('ejecuta...', history.location.pathname)
    // if (refInputSearch && refInputSearch.current) {
    //   refInputSearch.current.value = ""
    // }

    // setTitlevalue(addTitle[history.location.pathname] || '')
  }, [history.location])

  const onPressSearchItems = (): void => {
    if (headerActions) {
      headerActions.searchItems &&
        headerActions.searchItems(refSearchInput.current?.value)
      refSearchInput.current && (refSearchInput.current.value = '')
    }
  }

  return (
    <div
      className={ history.location.pathname === '/dashboard/dashboard/init' ? '' : "w-full lg:p-10 p-5 flex flex-nowrap items-center justify-between bg-transparent overflow-x-auto lg:overflow-visible"}
      style={{ height: history.location.pathname === '/dashboard/dashboard/init' ? '15px' : '100px' }}
    >
      <GiHamburgerMenu
        size="2rem"
        className="cursor-pointer lg:hidden"
        onClick={() => setCollapsed((prev) => !prev)}
      />
      
      <div className='flex flex-row items-center'>
        <h1 className="font-bold lg:text-2xl text-xl text-primary-900 dark:text-white mr-4">
          {title}
        </h1>

        { history.location.pathname === '/dashboard/asistentevirtual/init' && (
                      <div style={{padding: 7, backgroundColor: '#40826d'}} className='rounded-md'>
                          <label style={{color: 'white'}}>Beta</label>
                      </div>
                    )}


      </div>
      
      {headerActions && (
        <div
          className={`h-full flex space-x-4 ${
            location.pathname.includes('/historicoventas') ? 'items-center' : ''
          }`}
        >
          {headerActions.cleanFilters &&
            (isSearch ? (
              <Button
                onClick={() => {
                  headerActions.cleanFilters?.search &&
                    headerActions.cleanFilters.search()
                  setIsSearch(headerActions.cleanFilters?.isSearch)
                  setChecked(false)
                  // headerActions.cleanFilters?.sort &&
                  //   headerActions.cleanFilters.sort()
                  // if (refInputAdvanced && refInputAdvanced.current) {
                  //   refInputAdvanced.current.value = ''
                  // }
                }}
                icon={<MdDelete size="24px" />}
              >
                <span className="lg:block hidden">Limpiar Filtros</span>
              </Button>
            ) : null)}

          {}

          {headerActions.onCreatePaymentOrder && (
            <Button
              onClick={() =>
                headerActions.onCreatePaymentOrder &&
                headerActions.onCreatePaymentOrder()
              }
              type="primary"
              icon={<GiTakeMyMoney />}
            >
              <span className="lg:block hidden">Pagar</span>
            </Button>
          )}

          {headerActions.advancedSearch && (
            <>
              <AdvancedSearch
                onEnter={headerActions.advancedSearch}
                onPressFloating={headerActions.advancedSearch}
                ref={refInputAdvanced}
              />
            </>
          )}

          {headerActions.onChangeToDelivery && (
            <div className={`flex items-center justify-between w-32`}>
              <h1 className={`text-sm`}>{'Nota de entrega'}</h1>
              <Switch
                value={isDeliveryNote}
                onChange={(v) => {
                  headerActions.onChangeToDelivery &&
                    headerActions.onChangeToDelivery(v)
                  setIsDeliveryNote(v)
                }}
              />
            </div>
          )}

          {headerActions.onChangeSale && (
            <div className={`flex items-center justify-between w-32`}>
              <Switch
                value={isDeliveryNote}
                onChange={(v) => {
                  headerActions.onChangeToDelivery &&
                    headerActions.onChangeToDelivery(v)
                  setIsDeliveryNote(v)
                }}
              />
            </div>
          )}

          {headerActions.onSearch &&
            (headerActions.onSearch.tooltipMessage ? (
              <Tooltip
                key={headerActions.onSearch.tooltipMessage}
                title={headerActions.onSearch.tooltipMessage}
                position="bottom"
                xOffset={0}
                yOffset={0}
                show={true}
              >
                <div className="flex h-8">
                  <div className="dark:bg-primaryGray bg-primaryGray-500 rounded w-80 flex">
                    <div className="flex items-center mx-3">
                      <FiSearch />
                    </div>
                    <div className="w-full h-full">
                      <input
                        ref={headerActions.onSearch.ref}
                        className="bg-transparent border-transparent focus:outline-transparent w-full	h-full"
                        placeholder={headerActions.onSearch.placeholder}
                        onChange={(e) =>
                          headerActions.onSearch?.action(e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </Tooltip>
            ) : (
              <div className="flex">
                {/* <Button
                type="primary"
                onClick={() =>
                  headerActions.onSearch &&
                  headerActions.onSearch()
                }
              >
                <span className="lg:block hidden">Quitar Multiple borrado</span>
              </Button> */}
                {/* <input placeholder={headerActions.onSearch.placeholder} /> */}
                {/* <InputText onChange={(e) => console.log("target...", e.target.value)} /> */}
                <div className="bg-primaryGray rounded w-80 flex">
                  <div className="flex items-center mx-3">
                    <FiSearch />
                  </div>
                  <div className="w-full h-full">
                    <input
                      ref={headerActions.onSearch.ref}
                      className="bg-transparent border-transparent focus:outline-transparent w-full	h-full"
                      placeholder="Buscar"
                      onChange={(e) =>
                        headerActions.onSearch?.action(e.target.value)
                      }
                    />
                  </div>
                </div>
                {/* <Button
                onClick={() => {
                  headerActions.onSearch &&
                    headerActions.onSearch.action(
                      refInputSearch &&
                        refInputSearch.current &&
                        refInputSearch.current.value
                    )
                }}
                type="outline"
                classes="ml-2"
                icon={<FiSearch />}
              >
                <span className="lg:block hidden">Buscar</span>
              </Button> */}
              </div>
            ))}

          {headerActions.onPayed && (
            <div className="flex items-center justify-between w-32">
              <h1 className="text-sm">Pagado</h1>
              <Switch
                disabled={true}
                value={checkPayed}
                onChange={(v) => {
                  headerActions.onPayed &&
                    headerActions.onPayed(v, setCheckPayed)
                  setCheckPayed(v)
                }}
              />
            </div>
          )}

          {headerActions.onRevertDelivery && headerActions.onRevertDelivery && (
            <div className="flex items-center justify-between w-40">
              <h1 className="text-sm">Mostrar solo reversiones</h1>
              <Switch
                value={checkRevert}
                onChange={(v) => {
                  headerActions.onRevertDelivery &&
                    headerActions.onRevertDelivery(v, setCheckRevert)
                  setCheckRevert(v)
                }}
              />
            </div>
          )}

          {headerActions.onChangeDeliveryStatus && (
            <div className="w-52">
              <SelectOfCategories
                disabled={true}
                options={listOfDelivery}
                setSelectedHelper={(v) => {
                  headerActions.onChangeDeliveryStatus &&
                    headerActions.onChangeDeliveryStatus(v.value)

                  if (v.value === 'DISPATCHED') {
                    setCheckPayed(true)
                  } else {
                    setCheckPayed(false)
                  }
                }}
                label=""
                containerClasses="w-48"
                defaultValue={selectedDelivery}
              />
            </div>
          )}

          {headerActions.onChangeSaleType && (
            <div className="w-52" style={{ marginTop: -7 }}>
              <SelectOfCategories
                disabled={false}
                options={listOfSales}
                setSelectedHelper={(v) => {
                  headerActions.onChangeSaleType &&
                    headerActions.onChangeSaleType(v.value)
                }}
                label=""
                containerClasses="w-48"
                defaultValue={listOfSales[0]}
              />
            </div>
          )}

          {headerActions.onChangeTypePending && (
            <div className="w-52">
              <SelectOfCategories
                disabled={false}
                options={listOfSalesType}
                setSelectedHelper={(v) => {
                  headerActions.onChangeTypePending &&
                    headerActions.onChangeTypePending(v.value)
                }}
                label=""
                containerClasses="w-48"
                defaultValue={listOfSalesType[0]}
              />
            </div>
          )}

          {headerActions.onChangeType && headerActions.onFilterSales && (
            <div className="flex justify-between">
              <div className="w-52">
                <SelectOfCategories
                  options={listOfTypes}
                  setSelectedHelper={(v) => {
                    headerActions.onChangeType &&
                      headerActions.onChangeType(v.value)
                  }}
                  label="Tipo de venta"
                  containerClasses="w-48"
                  defaultValue={listOfTypes[0]}
                />
              </div>
              <div className="flex items-center justify-between w-52">
                <p>Mostrar solo devoluciones</p>
                <Switch
                  value={checked}
                  onChange={(v) => {
                    headerActions.onFilterSales &&
                      headerActions.onFilterSales(v)
                    setChecked(v)
                  }}
                />
              </div>
            </div>
          )}

          {headerActions.onFreeForm && (
            <div className="flex items-center justify-between w-40">
              <h1 className="text-sm">Forma libre</h1>
              <Switch
                value={checkedSale}
                onChange={(v) => {
                  headerActions.onFreeForm &&
                    headerActions.onFreeForm(v, setCheckedSale)
                  setCheckedSale(v)
                  setIsModifyFreeForm(true)
                }}
              />
            </div>
          )}

          {headerActions.searchAction && (
            <div
              className={`flex ${
                location.pathname.includes('/historicoventas')
                  ? 'items-center'
                  : ''
              }`}
            >
              <Button
                onClick={() => {
                  headerActions.searchAction && headerActions.searchAction()
                  setIsSearch(headerActions.cleanFilters?.isSearch)
                }}
                type="outline"
                icon={<RiArrowDownSLine />}
                isIconLeft={false}
              >
                <span className="lg:block hidden">Buscar</span>
              </Button>
            </div>
          )}

          {headerActions.addEmployee && (
            <Button
            onClick={() =>
              headerActions.addEmployee &&
              headerActions.addEmployee()
            }
            type="primary"
          >
            <span className="lg:block hidden">Añadir empleado</span>
          </Button>
          )}

          {headerActions.addAction &&
          userRole['custom:user_plan'] === 'emprendedor' && history.location.pathname === '/dashboard/inventario/existencia' ? (
            <Tooltip title='Suscríbete al Plan PYME para acceder a esta función' position='left'>
            <Button
              onClick={() =>
                headerActions.addAction && headerActions.addAction()
              }
              type="primary"
              icon={<HiOutlinePlus />}
              classes="rounded-md"
              disabled={true}
            >
              <span className="lg:block hidden">{`Añadir ${
                addTitle[history.location.pathname] || ''
              }`}</span>
            </Button>
            </Tooltip>
          ) : headerActions.addAction && (
            <Button
              onClick={() =>
                headerActions.addAction && headerActions.addAction()
              }
              type="primary"
              icon={<HiOutlinePlus />}
              classes="rounded-md"
            >
              <span className="lg:block hidden">{`Añadir ${
                addTitle[history.location.pathname] || ''
              }`}</span>
            </Button>
          )}

          {headerActions.onCreateRecovery && (
            <Button
              onClick={() =>
                headerActions.onCreateRecovery &&
                headerActions.onCreateRecovery()
              }
              type="primary"
              icon={<GiTakeMyMoney />}
            >
              <span className="lg:block hidden">Cobrar</span>
            </Button>
          )}

          {headerActions.readMode && (
            <Button
              onClick={() => headerActions.readMode && headerActions.readMode()}
              type="primary"
              icon={<AiOutlineRead />}
            >
              <span className="lg:block hidden">Lectura</span>
            </Button>
          )}

          {headerActions.onCreatePaymentOrderRequest && (
            <Button
              onClick={() =>
                headerActions.onCreatePaymentOrderRequest &&
                headerActions.onCreatePaymentOrderRequest()
              }
              type="primary"
              icon={<IoIosCloudDone />}
            >
              <span className="lg:block hidden">Completar</span>
            </Button>
          )}

          {headerActions.searchItems && (
            <div className="flex w-72 justify-between">
              <input
                type="text"
                className="dark:bg-gray-600 dark:border-gray-600 h-8 dark:text-white mr-2"
                name="cedula"
                placeholder="Consultar precio"
                autoComplete="off"
                ref={refSearchInput}
                onKeyDown={(e) => e.key === 'Enter' && onPressSearchItems()}
              />
              <Button type="primary" onClick={() => onPressSearchItems()}>
                <span className="lg:block hidden">Buscar</span>
              </Button>
            </div>
          )}

          {headerActions.multiDeletePendingSells && (
            <div>
              <Button
                type="primary"
                onClick={() =>
                  headerActions.multiDeletePendingSells &&
                  headerActions.multiDeletePendingSells()
                }
              >
                <span className="lg:block hidden">Borrado Multiple</span>
              </Button>
            </div>
          )}

          {headerActions.onShowRate && (
            <div className='flex'>
              <label className='font-semibold'>Tasa Bs/USD: Bs.{formatPipe(toFixed(+(rates?.find(rate => rate?.id === "1")?.rate || 0), 2).replace('.', ','))}</label>
              {/* <button onClick={async () => {
                let usbDeviceProperties = [{ name: "The Factory HKA. ", vendorId: 1240, productId: 10 }]
                try {
                  //@ts-ignore
                let device = await navigator.usb.requestDevice({ filters: usbDeviceProperties });
                await device.open()
            await device.selectConfiguration(1)
            await device.claimInterface(0)
            await device.controlTransferOut({
              requestType: 'vendor',
              recipient: 'interface',
              request: 0x01,  // vendor-specific request: enable channels
              value: 0x0013,  // 0b00010011 (channels 1, 2 and 5)
              index: 0x0001   // Interface 1 is the recipient
      })
                console.log("device", device)
        } catch (error: any) {
          alert('Error: ' + error.message);
        }
              }}>Prueba</button> */}
            </div>
          )}

          {headerActions.onCloseBox && (
            <div>
            <Button
              type="primary"
              onClick={() =>
                headerActions.onCloseBox &&
                headerActions.onCloseBox()
              }
            >
              <span className="lg:block hidden">Cierre de Caja</span>
            </Button>
          </div>
          )}

          {headerActions.quitDeletePendingSells && (
            <div>
              <Button
                type="primary"
                onClick={() =>
                  headerActions.quitDeletePendingSells &&
                  headerActions.quitDeletePendingSells()
                }
              >
                <span className="lg:block hidden">Quitar Multiple borrado</span>
              </Button>
            </div>
          )}

          {headerActions.onDeletePending && (
            <div>
              <Button
                type="primary"
                onClick={() =>
                  headerActions.onDeletePending &&
                  headerActions.onDeletePending()
                }
              >
                <span className="lg:block hidden">Borrar</span>
              </Button>
            </div>
          )}

          {headerActions.onChangeReconcile && (
            <Button
              onClick={() =>
                headerActions.onChangeReconcile &&
                headerActions.onChangeReconcile()
              }
              type="primary"
              icon={<GiTakeMyMoney />}
            >
              <span className="lg:block hidden">Conciliar</span>
            </Button>
          )}

          {headerActions.onPending && (
            <div
              className={`${
                location.pathname.includes('/notadeentrega')
                  ? 'flex items-center'
                  : null
              }`}
            >
              <Button
                type="primary"
                onClick={() =>
                  headerActions.onPending && headerActions.onPending()
                }
              >
                <span className="lg:block hidden">Pendiente</span>
              </Button>
            </div>
          )}

          {headerActions.onAdjust && (
            <Button
              onClick={() => headerActions.onAdjust && headerActions.onAdjust()}
              type="primary"
              icon={<HiOutlinePlus />}
            >
              <span className="lg:block hidden">Ajustar</span>
            </Button>
          )}

          {headerActions.onPrint && (
            <Button
              onClick={() => headerActions.onPrint && headerActions.onPrint()}
              type="primary"
              icon={<AiFillPrinter className="text-success" size="1.1rem" />}
            >
              <span className="lg:block hidden">Imprimir</span>
            </Button>
          )}
          {console.log(
            'headerActions.onDeliveryNoteOrPurchaseLoad: ',
            headerActions.onDeliveryNoteOrPurchaseLoad
          )}
          {headerActions.onDeliveryNoteOrPurchaseLoad && (
            <div className="flex items-center justify-between w-60">
              <span className="text-sm">Factura</span>
              <Switch
                value={headerActions.onDeliveryNoteOrPurchaseLoad.getMode}
                onChange={(v) => {
                  headerActions.onDeliveryNoteOrPurchaseLoad?.setMode &&
                    headerActions.onDeliveryNoteOrPurchaseLoad?.setMode(
                      (prev) => !prev
                    )
                }}
              />
              <span className="text-sm">Nota de Entrega</span>
            </div>
          )}

          {headerActions.onCustomAction?.map((button) =>
            button.tooltipMessage ? (
              <Tooltip
                key={button.tooltipMessage}
                title={button.tooltipMessage}
                position="bottom"
                xOffset={0}
                yOffset={0}
                show={true}
              >
                {button.display && (
                  <Button
                    onClick={() => button?.action()}
                    type={button?.buttonType || 'primary'}
                    icon={button?.icon}
                  >
                    <span className="lg:block hidden">{button?.title}</span>
                  </Button>
                )}
              </Tooltip>
            ) : (
              <>
                {button.display && (
                  <Button
                    onClick={() => button?.action()}
                    type={button?.buttonType || 'primary'}
                    icon={button?.icon}
                  >
                    <span className="lg:block hidden">{button?.title}</span>
                  </Button>
                )}
              </>
            )
          )}
        </div>
      )}

      {!headerActions && (
        //To center the title on mobile
        <div></div>
      )}

      <ModalConfirm
        positive={true}
        displayConfirmModal={isModifyFreeForm}
        title={msgToShow[+checkedSale]}
        onCancel={() => {
          setCheckedSale((prevState) => !prevState)
          setIsModifyFreeForm(false)
          headerActions &&
            headerActions.onFreeForm &&
            headerActions.onFreeForm(!checkedSale)
        }}
        onConfirm={() => setIsModifyFreeForm(false)}
      />
    </div>
  )
}

export default Header

export interface HeaderProps {
  title: string | ReactNode
  setCollapsed: Function
  headerActions?: {
    addAction?: Function
    addEmployee?: Function
    searchAction?: Function
    cleanFilters?: {
      search: Function
      sort?: Function
      isSearch?: boolean
    }
    searchItems?: Function
    multiDeletePendingSells?: Function
    quitDeletePendingSells?: Function
    onDeletePending?: Function
    onPending?: Function
    onFilterSales?: Function
    onFreeForm?: Function
    onChangeType?: Function
    onPayed?: Function
    onChangeDeliveryStatus?: Function
    onRevertDelivery?: Function
    onChangeTypePending?: Function
    // Existences
    onAdjust?: Function
    onPrint?: Function
    onCreatePaymentOrder?: Function
    readMode?: Function
    onCreatePaymentOrderRequest?: Function
    onCreateRecovery?: Function
    onDeliveryNoteOrPurchaseLoad?: {
      setMode: Function
      getMode: boolean
    }
    onCustomAction?: {
      title: string
      icon: React.ReactElement
      buttonType: ButtonType
      action: Function
      display: boolean
      tooltipMessage?: string
    }[]
    onChangeToDelivery?: Function
    onSearch?: InputSearch
    onChangeSale?: Function
    onChangeSaleType?: Function
    advancedSearch?: Function
    onChangeReconcile?: Function
    onShowRate?: Function
    onCloseBox?: Function
  } | null
}

interface InputSearch {
  placeholder: string
  icon?: React.ReactElement | null
  action: Function
  display: boolean
  ref: React.RefObject<HTMLInputElement>
  tooltipMessage?: string
}
